import { defineComponent as _defineComponent } from 'vue'
import { notification } from 'ant-design-vue';
import { computed, ref } from 'vue';
import ProjectAPI from '@/api/ProjectAPI';
import i18n from '@/i18n';
import store from '@/store';

/* === Remote Help State === */

export default /*#__PURE__*/_defineComponent({
  __name: 'HelpPage',
  setup(__props) {

const displayHelperPopup = ref(false);
const displayProjectPopup = ref(false);
const displayNextArrow = ref(true);
const displayPrevArrow = ref(false);
const projectInfo = ref<Record<string, unknown>>({});
const projectID = ref(1);
const textContent = [
    'Click CTRL+WIN+Q keys at the same time.',
    'Get code from ROLTEK assistant, input it and click SHARE SCREEN.',
    'Click on Allow access.',
    'Click on allow control.',
];
const images = require.context('../../../public/help-page/', false, /\.jpg$/);

/* === Help Content === */
const allowRoltekHelpChange = computed(() => {
    const currentUserGroup = String(store.getters['jwtData/currentUserGroup']);
    return currentUserGroup in ['1', '2', '3'];
});

const currentLocale = computed(() => i18n?.locale ?? 'sl');

const isMobile = computed(() => {
    if (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
    }

    return window.matchMedia('only screen and (max-width: 28.125rem)').matches;
});

const helpPageData = computed(() =>
    textContent.map((description, index) => ({
        description,
        img:
            index === 3
                ? require('../../../public/help-desk.svg')
                : getImgLocation(`${currentLocale.value}_${index + 1}.jpg`, `${index + 1}`),
    })),
);

function getImgLocation(imgName: string, imgNumber: string) {
    if (images.keys().includes(`./${imgName}`)) {
        return images(`./${imgName}`);
    }

    return images(`./en_${imgNumber}.jpg`);
}

function menuItemClicked(event: Event) {
    if (!isMobile.value) {
        event.preventDefault();
    }
}

/* === Project Help Administration === */
async function getProjectInfo() {
    // @ts-ignore
    document.querySelector('.ant-popover').style = 'display: none;';
    try {
        const response = await store.dispatch('generic/getProjectInfo', projectID.value);
        projectInfo.value = response.data;
        showProjectPopup();
    } catch (error) {
        notification.error({
            message: i18n.t('Project with this ID not found') as string,
            description: (error as Error).message,
        });
    }
}

async function updateProject() {
    try {
        await ProjectAPI.updateRoltekHelp(projectID.value.toString());
    } catch (error) {
        return Promise.reject(error);
    }
    closeProjectModal();
}

function closeModal() {
    displayHelperPopup.value = false;
}

function closeProjectModal() {
    displayProjectPopup.value = false;
}

function showHelperPopup() {
    displayHelperPopup.value = true;
    // @ts-ignore
    document.querySelector('.ant-popover').style = 'display: none;';
}

function showProjectPopup() {
    displayProjectPopup.value = true;
}

function handleOk() {
    displayHelperPopup.value = false;
}

function setArrowVisibility(_data: unknown, index: number) {
    displayNextArrow.value = index !== 3;
    displayPrevArrow.value = index !== 0;
}

return { __sfc: true,displayHelperPopup, displayProjectPopup, displayNextArrow, displayPrevArrow, projectInfo, projectID, textContent, images, allowRoltekHelpChange, currentLocale, isMobile, helpPageData, getImgLocation, menuItemClicked, getProjectInfo, updateProject, closeModal, closeProjectModal, showHelperPopup, showProjectPopup, handleOk, setArrowVisibility }
}

})